import { render, staticRenderFns } from "./tabss.vue?vue&type=template&id=344d9877&scoped=true&"
import script from "./tabss.vue?vue&type=script&lang=js&"
export * from "./tabss.vue?vue&type=script&lang=js&"
import style0 from "./tabss.vue?vue&type=style&index=0&id=344d9877&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344d9877",
  null
  
)

export default component.exports